import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function replaceResponse(_this__u8e3s4, headers, content) {
  headers = headers === VOID ? _this__u8e3s4.h5m().b56() : headers;
  return DelegatedCall().f5o(_this__u8e3s4.c5m_1, _this__u8e3s4, content, headers);
}
var DelegatedCallClass;
function DelegatedCall() {
  if (DelegatedCallClass === VOID) {
    class $ extends HttpClientCall() {
      static f5o(client, originCall, responseContent, responseHeaders) {
        responseHeaders = responseHeaders === VOID ? originCall.h5m().b56() : responseHeaders;
        var $this = this.g5o(client);
        $this.e5m_1 = new (DelegatedRequest())($this, originCall.h5o());
        $this.f5m_1 = new (DelegatedResponse())($this, originCall.h5m(), responseContent, responseHeaders);
        return $this;
      }
    }
    initMetadataForClass($, 'DelegatedCall', VOID, VOID, VOID, [0, 1]);
    DelegatedCallClass = $;
  }
  return DelegatedCallClass;
}
var DelegatedRequestClass;
function DelegatedRequest() {
  if (DelegatedRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.m5o_1 = origin;
        this.n5o_1 = call;
      }
      o5o() {
        return this.n5o_1;
      }
      gw() {
        return this.m5o_1.gw();
      }
      p5o() {
        return this.m5o_1.p5o();
      }
      q5o() {
        return this.m5o_1.q5o();
      }
      i5o() {
        return this.m5o_1.i5o();
      }
      a2p() {
        return this.m5o_1.a2p();
      }
      b56() {
        return this.m5o_1.b56();
      }
    }
    initMetadataForClass($, 'DelegatedRequest', VOID, VOID, [HttpRequest()]);
    DelegatedRequestClass = $;
  }
  return DelegatedRequestClass;
}
var DelegatedResponseClass;
function DelegatedResponse() {
  if (DelegatedResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, origin, content, headers) {
        headers = headers === VOID ? origin.b56() : headers;
        super();
        this.r5o_1 = call;
        this.s5o_1 = origin;
        this.t5o_1 = content;
        this.u5o_1 = headers;
        this.v5o_1 = this.s5o_1.gw();
      }
      o5o() {
        return this.r5o_1;
      }
      b56() {
        return this.u5o_1;
      }
      w5o() {
        return this.t5o_1(this.s5o_1);
      }
      gw() {
        return this.v5o_1;
      }
      x5o() {
        return this.s5o_1.x5o();
      }
      y5o() {
        return this.s5o_1.y5o();
      }
      z5o() {
        return this.s5o_1.z5o();
      }
      a5p() {
        return this.s5o_1.a5p();
      }
    }
    initMetadataForClass($, 'DelegatedResponse');
    DelegatedResponseClass = $;
  }
  return DelegatedResponseClass;
}
//region block: exports
export {
  replaceResponse as replaceResponse3ut5eo3odxj99,
};
//endregion

//# sourceMappingURL=DelegatedCall.mjs.map
